import { Carousel as MantineCarousel, CarouselProps as MantineCarouselProps } from '@mantine/carousel';
import {PropsWithChildren} from "react";

export type CarouselProps = Omit<MantineCarouselProps, 'children'> & {
  // extended props here
}

export const Carousel = (props: PropsWithChildren<CarouselProps>) => {
  const {children, ...rest} = props
  return (
    <MantineCarousel {...rest}>
      {children}
    </MantineCarousel>
  )
}

Carousel.Slide = MantineCarousel.Slide
